<template>
  <label class="ui-field">
    <span v-if="label">{{ label }}</span>
    <input
      :value="value"
      :placeholder="placeholder"
      v-bind="$attrs"
      class="ui-input"
      @input="$emit('input', $event.target.value)"
    >
  </label>
</template>

<script>
export default {
  name: 'UiInput',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.ui-field {
  display: grid;
  gap: 6px;
  min-width: 0;
}

.ui-field span {
  color: hsl(var(--muted-foreground));
  font-size: 0.72rem;
  font-weight: 700;
}

.ui-input {
  width: 100%;
  min-height: 40px;
  min-width: 0;
  padding: 0 12px;
  border: 1px solid hsl(var(--border));
  border-radius: 10px;
  outline: none;
  background: hsl(var(--input));
  color: hsl(var(--foreground));
  font: inherit;
  font-size: 0.9rem;
}

.ui-input::placeholder {
  color: hsl(var(--muted-foreground));
}

.ui-input:focus {
  border-color: hsl(var(--ring));
}
</style>
